import React from 'react'
import PropTypes from 'prop-types'
import './NewHomeQuickAccessCard.css'

import iconAdd from 'images/add-fill.svg'
import ExclusionModal from '../ExclusionModal/ExclusionModal'
import Close from 'images/close-green.svg'

const NewHomeQuickAccessCard = ({
  t,
  title,
  isFilled,
  iconName,
  onClick,
  onRemove,
}) => (
  <div
    className={`new-home-quick-access-card ${isFilled ? 'active' : ''}`}
    onClick={onClick}
  >
    {isFilled && (
      <div
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <ExclusionModal
          t={t}
          title={t('new.home.quickAccess.remove.title')}
          message={t('new.home.quickAccess.remove.description')}
          onConfirm={onRemove}
          renderButton={({ onClick }) => (
            <img
              className='close-icon'
              src={Close}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onClick && onClick()
              }}
            />
          )}
        />
      </div>
    )}
    {iconName ? <i className={`glyph ${iconName}`} /> : <img src={iconAdd} />}
    <span className='title'>{title}</span>
  </div>
)

NewHomeQuickAccessCard.propTypes = {
  title: PropTypes.string.isRequired,
  isFilled: PropTypes.bool,
  t: PropTypes.func,
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  iconName: PropTypes.string,
}

NewHomeQuickAccessCard.defaultProps = {
  isFilled: false,
}

export default NewHomeQuickAccessCard
